(ns ycweb.components.state)

(def app (atom nil))

(defn register-app! [app-key]
  (= app-key (swap! app (fn [s] (or s app-key)))))

(defn scroll-position []
  #?(:cljs
     {:x (.-scrollX js/window) :y (.-scrollY js/window)}
     :clj
     {:x 0 :y 0}))

(defn screen-size []
  #?(:cljs
     {:width (.-innerWidth js/window)
      :height (.-innerHeight js/window)}
     :clj
     {:width 0
      :height 0}))